import { useEffect, useRef, useState } from "react";
import { PulseLoader } from "react-spinners";
import {
  getStorage,
  ref,
  getDownloadURL,
  deleteObject,
  getMetadata,
  uploadBytes,
} from "firebase/storage";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  getCookie,
  fetchData,
  getUserList,
  getCourseList,
  getStoragePath,
  getFileName,
  setCookie,
} from "../../util";
import Code from "../../components/Code";
import Search from "../../components/Search";
import Table from "./Table";
import GroupModal from "./GroupModal";
import PdfModal from "./PdfModal";
import "./index.css";
import GroupInfoModal from "./GroupInfoModal";

function AdminPage() {
  const storage = getStorage();
  const [isAdmin, setIsAdmin] = useState(getCookie("isadmin"));
  const [userInfo, setUserInfo] = useState(getCookie("userinfo"));
  const [groupUsers, setGroupUsers] = useState([]);
  const code = process.env.REACT_APP_ADMIN;
  const modalRef = useRef(null);
  const [keyword, setKeyword] = useState("");
  const [detailKeyword, setDetailKeyword] = useState("");
  const [courses, setCourses] = useState([]);
  const [data, setData] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  const [detailData, setDetailData] = useState([]);
  const [isAscending, setIsAscending] = useState(true);
  const headers = [
    "checkbox",
    { id: "company", name: "회사" },
    { id: "affiliation", name: "소속" },
    { id: "position", name: "직급" },
    { id: "name", name: "이름" },
    { id: "email", name: "이메일" },
    { id: "phonenumber", name: "전화번호" },
    { id: "course", name: "과정명" },
    { id: "code", name: "코드" },
    { id: "mainType", name: "Main type" },
    { id: "subType", name: "Sub type" },
    "buttons",
  ];
  const widths = [4, 10, 10, 9, 8, 20, 15, 15, 5, 8, 8, 10];
  const [sortBy, setSortBy] = useState(headers[1]);
  const [showInputModal, setShowInputModal] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [input, setInput] = useState({
    companyname: "",
    groupname: "",
    date: "",
  });
  const [groupscore, setGroupscore] = useState([]);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const [excelDataMain, setExcelDataMain] = useState([]);
  const [excelDataSub, setExcelDataSub] = useState([]);
  const [dataMain, setDataMain] = useState([]);
  const [dataSub, setDataSub] = useState([]);
  const pdfRef = useRef(null);
  const [tempUserInfo, setTempUserInfo] = useState(null);

  useEffect(() => {
    initData();
    getCourses();
    try {
      fetchData("result-sub.xlsx").then((res) => setExcelDataSub(res));
      fetchData("result-main.xlsx").then((res) => setExcelDataMain(res));
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (userInfo && excelDataMain && excelDataSub) {
      let arraySub = excelDataSub.filter(
        (item) => item.type === userInfo.subType
      );
      setDataSub({
        strength: arraySub.filter(
          (item) =>
            item.category.includes("strength") || item.category === "content"
        ),
        weakness: arraySub.filter((item) => item.category.includes("weakness")),
        behavior: arraySub.filter(
          (item) =>
            item.category.includes("like") || item.category.includes("opposite")
        ),
      });
      let arrayMain = excelDataMain.filter(
        (item) => item.type === userInfo.mainType
      );
      setDataMain({
        keywords: arrayMain.filter((item) => item.category === "keywords"),
        strength: arrayMain.filter(
          (item) =>
            item.category.includes("strength") &&
            !item.category.includes("stress")
        ),
        weakness: arrayMain.filter((item) =>
          item.category.includes("weakness")
        ),
        work_style: arrayMain.filter(
          (item) =>
            item.category === "work_style" || item.category === "leadership"
        ),
        changes: arrayMain.filter(
          (item) =>
            item.category === "change_res" || item.category === "conflict"
        ),
        motivation: arrayMain.filter((item) =>
          item.category.includes("motivation")
        ),
        stress: arrayMain.filter((item) => item.category.includes("stress")),
        cowork: arrayMain.filter((item) => item.category === "cowork"),
      });
    }
  }, [userInfo, excelDataMain, excelDataSub, tempUserInfo]);

  useEffect(() => {
    getSearchedData();
  }, [data, detailKeyword]);

  useEffect(() => {
    setDetailKeyword("");
    getSearchedData();
  }, [keyword]);

  const initData = async () => {
    const insertAt = (obj, key, value, index) => {
      const entries = Object.entries(obj);
      entries.splice(index, 0, [key, value]);
      return Object.fromEntries(entries);
    };

    setLoading(true);
    try {
      getScoreData();
      const userList = await getUserList();
      const courseList = await getCourseList();
      const formattedList = userList.map((item) => {
        const matchedCode = courseList.filter(
          (course) => item.course === course.name
        )[0].code;
        const newItem = insertAt(item, "code", matchedCode, 8);
        return {
          ...newItem,
          email: newItem.email.replace(/&/g, `_`),
        };
      });
      setData(formattedList);
      if (!keyword) setSearchedData(formattedList);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getScoreData = async () => {
    const scoreRef = ref(storage, "userdata/scoredata");
    getDownloadURL(scoreRef)
      .then((url) => fetch(url))
      .then((response) => response.json())
      .then((data) => {
        setCookie("scoredataA", data.slice(0, 2));
        setCookie("scoredataR", data.slice(2, 4));
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  const getCourses = async () => {
    setLoading(true);
    try {
      const courseList = await getCourseList();
      setCourses(courseList);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getSearchedData = () => {
    setSortBy(headers[1]);
    setIsAscending(true);
    const searched = data.filter((item) => {
      let hasKeyword = false;
      Object.values(item).map((i) => {
        if (
          typeof i === "string" &&
          i.toUpperCase().includes(keyword.toUpperCase())
        )
          hasKeyword = true;
      });
      return hasKeyword;
    });
    setSearchedData(searched);
    if (detailKeyword)
      setDetailData(
        searched.filter((item) => {
          let hasKeyword = false;
          Object.values(item).map((i) => {
            if (
              typeof i === "string" &&
              i.toUpperCase().includes(detailKeyword.toUpperCase())
            )
              hasKeyword = true;
          });
          return hasKeyword;
        })
      );
  };

  const handleDownloadExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(
      data.map(({ isChecked, ...rest }) => rest)
    );
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "SEAL 진단 사용 목록.xlsx");
  };

  const sortDataFunc = async (sortBy, isAscending) => {
    setLoading(true);
    try {
      const compare = (a, b) => {
        if (a[sortBy] > b[sortBy]) return 1;
        if (a[sortBy] < b[sortBy]) return -1;
        return 0;
      };
      const reverseCompare = (a, b) => {
        if (a[sortBy] < b[sortBy]) return 1;
        if (a[sortBy] > b[sortBy]) return -1;
        return 0;
      };
      if (detailKeyword)
        setDetailData(detailData.sort(isAscending ? compare : reverseCompare));
      else
        setSearchedData(
          searchedData.sort(isAscending ? compare : reverseCompare)
        );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckBox = async (type) => {
    const targetData = detailKeyword ? detailData : searchedData;
    let users = [];

    setLoading(true);
    for (let i = 0; i < targetData.length; i++) {
      const user = {
        ...targetData[i],
        email: targetData[i].email.replace(/_/g, `&`),
      };
      if (user.isChecked) users.push(user);
    }

    if (users.length < 1) {
      alert(`하나 이상의 항목을 선택해주세요.`);
      setLoading(false);
      return;
    } else if (type === "del")
      if (!window.confirm(`${users.length}개 항목 삭제`)) {
        setLoading(false);
        return;
      }
    try {
      if (type === "del") handleDelete(users).then(() => initData());
      else if (type === "group") handleGroupScore(users);
      else if (type === "download") handlePdfMultiple(users);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      if (type === "del") {
        initData();
        alert("삭제되었습니다");
      }
    }
  };

  const handleDelete = async (users) => {
    const deleteUser = async (user) => {
      const scoreRef = ref(storage, "userdata/scoredata");
      const pathReference = ref(storage, getStoragePath(user));
      let scoredata;
      setLoading(true);

      await getDownloadURL(scoreRef)
        .then((url) => fetch(url))
        .then((response) => response.json())
        .then((data) => {
          scoredata = data;
        });
      await getDownloadURL(pathReference)
        .then((url) => fetch(url))
        .then((response) => response.json())
        .then((data) => {
          if (data.state) {
            const updatedData = scoredata.map((pagedata) =>
              pagedata.map((questiondata) => {
                let newItem;
                data.state.map((page) =>
                  page.map((question) => {
                    if (question.id === questiondata.id) {
                      if (question.id.startsWith("ABS"))
                        newItem = {
                          ...questiondata,
                          [question.isPos
                            ? question.value - 1
                            : 5 - question.value]:
                            questiondata[
                              question.isPos
                                ? question.value - 1
                                : 5 - question.value
                            ] - 1,
                        };
                      else
                        newItem = {
                          ...questiondata,
                          [question.answerId.slice(3, 4) - 1]:
                            questiondata[question.answerId.slice(3, 4) - 1] - 1,
                        };
                    }
                  })
                );
                return newItem;
              })
            );
            const fileContent = JSON.stringify(updatedData, null, 2);
            const blob = new Blob([fileContent], {
              type: "application/json",
            });
            uploadBytes(scoreRef, blob)
              .then((snapshot) => getDownloadURL(snapshot.ref))
              .then(() => {
                console.log("Score uploaded successfully");
              });
          }
          deleteObject(pathReference);
        });
    };
    users.map((user) => {
      deleteUser(user);
    });
  };

  const handleGroupScore = async (users) => {
    setGroupUsers(users);
    setShowInputModal(true);
    setLoading(true);

    const scoreRef = ref(storage, "userdata/scoredata");
    let scoredata;
    await getDownloadURL(scoreRef)
      .then((url) => fetch(url))
      .then((response) => response.json())
      .then((data) => {
        scoredata = data.map((page) =>
          page.map((item) => {
            return { id: item.id, 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 };
          })
        );
      });

    const setGroupScore = async (user) => {
      const pathReference = ref(storage, getStoragePath(user));
      await getDownloadURL(pathReference)
        .then((url) => fetch(url))
        .then((response) => response.json())
        .then((data) => {
          if (data.state) {
            const updatedData = scoredata.map((pagedata) =>
              pagedata.map((questiondata) => {
                let newItem;
                data.state.map((page) =>
                  page.map((question) => {
                    if (question.id === questiondata.id) {
                      if (question.id.startsWith("ABS"))
                        newItem = {
                          ...questiondata,
                          [question.isPos
                            ? question.value - 1
                            : 5 - question.value]:
                            questiondata[
                              question.isPos
                                ? question.value - 1
                                : 5 - question.value
                            ] + 1,
                        };
                      else
                        newItem = {
                          ...questiondata,
                          [question.answerId.slice(3, 4) - 1]:
                            questiondata[question.answerId.slice(3, 4) - 1] + 1,
                        };
                    }
                  })
                );
                return newItem;
              })
            );
            scoredata = updatedData;
          }
        });
    };

    users.map((user) => {
      setGroupScore(user).then(() => setGroupscore(scoredata));
    });
    console.log("scoredata:", scoredata);
    console.log("users:", users);
  };

  const handlePdfMultiple = async (users) => {
    setPdfLoading(true);
    for (const user of users) {
      try {
        setTempUserInfo(user);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await handlePdfOpenAndDownload(user);
      } catch (error) {
        console.error(`PDF 생성 실패 (${user.name}):`, error);
      }
    }
    setPdfLoading(false);
    setTempUserInfo(null);
  };

  const handlePdfOpenAndDownload = async (user) => {
    const storageRef = ref(storage, getStoragePath(user));

    try {
      const url = await getDownloadURL(storageRef);
      const response = await fetch(url);
      const data = await response.json();

      setCookie("userinfo", user);
      setCookie("scoremain", data.scoreMain);
      setCookie("scoresub", data.scoreSub);
      setUserInfo(user);

      await new Promise((resolve) => setTimeout(resolve, 100));

      const doc = new jsPDF("p", "mm", "a4");
      const element = pdfRef.current;
      if (element) {
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          logging: false,
          allowTaint: true,
          imageTimeout: 0,
          onclone: (clonedDoc) => {
            return new Promise((resolve) => setTimeout(resolve, 500));
          },
        });
        const imageFile = canvas.toDataURL("image/jpeg");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const widthRatio = pageWidth / canvas.width;
        const customHeight = canvas.height * widthRatio;

        doc.addImage(imageFile, "jpeg", 0, 0, pageWidth, customHeight);
        let heightLeft = customHeight;
        let heightAdd = -pageHeight;

        while (heightLeft >= pageHeight) {
          doc.addPage();
          doc.addImage(
            imageFile,
            "jpeg",
            0,
            heightAdd,
            pageWidth,
            customHeight
          );
          heightLeft -= pageHeight;
          heightAdd -= pageHeight;
        }

        doc.save(getFileName(user.name));
      }
    } catch (error) {
      throw error;
    }
  };

  const handlePdfOpen = (user) => {
    setUserInfo(user);
    const storageRef = ref(storage, getStoragePath(user));

    getDownloadURL(storageRef)
      .then((url) => fetch(url))
      .then((response) => response.json())
      .then((data) => {
        setCookie("userinfo", user);
        setCookie("scoremain", data.scoreMain);
        setCookie("scoresub", data.scoreSub);
        setShowPdfModal(true);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  const onClickDownloadPdf = async () => {
    const storageRef = ref(storage, getStoragePath(userInfo));
    const metadata = await getMetadata(storageRef);
    const contentType = metadata.contentType;
    const doc = new jsPDF("p", "mm", "a4");
    setPdfLoading(true);
    if (contentType === "application/json" || contentType === "application/pdf")
      try {
        const element = pdfRef.current;
        if (element) {
          const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
          });
          const imageFile = canvas.toDataURL("image/jpeg");
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          const widthRatio = pageWidth / canvas.width;
          const customHeight = canvas.height * widthRatio;
          doc.addImage(imageFile, "jpeg", 0, 0, pageWidth, customHeight);
          let heightLeft = customHeight;
          let heightAdd = -pageHeight;
          while (heightLeft >= pageHeight) {
            doc.addPage();
            doc.addImage(
              imageFile,
              "jpeg",
              0,
              heightAdd,
              pageWidth,
              customHeight
            );
            heightLeft -= pageHeight;
            heightAdd -= pageHeight;
          }
          doc.save(getFileName(userInfo.name));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setPdfLoading(false);
      }
  };

  const onClickDownloadGroupModalPdf = async () => {
    const pdf = new jsPDF("l", "mm", "a4"); // "l"로 가로 A4 설정
    const pageWidth = pdf.internal.pageSize.getWidth(); // A4 가로 길이 (297mm)
    const pageHeight = pdf.internal.pageSize.getHeight(); // A4 세로 길이 (210mm)

    const elements = [
      document.querySelector(".GroupCovers"),
      document.querySelector(".GroupTables"),
      ...document.querySelectorAll(".GroupCircle"),
      ...document.querySelectorAll(".GroupQuarter"),
      ...document.querySelectorAll(".GroupCharacter"),
      ...document.querySelectorAll(".Statistic"),
    ]; // 각 섹션을 선택

    // 각 섹션을 개별적으로 캡처하여 PDF에 추가
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (element) {
        // 섹션을 캡처
        const canvas = await html2canvas(element, { scale: 2, useCORS: true });
        const imageFile = canvas.toDataURL("image/jpeg");

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const widthRatio = pageWidth / canvasWidth; // A4 크기에 맞추기 위한 비율
        const customHeight = canvasHeight * widthRatio; // 비율에 맞춰 계산된 높이

        // 이미지가 한 페이지에 들어가면 추가
        if (customHeight <= pageHeight) {
          pdf.addImage(imageFile, "JPEG", 0, 0, pageWidth, customHeight);
        } else {
          // 이미지가 한 페이지에 들어가지 않으면 페이지를 추가하여 나누기
          let heightLeft = customHeight;
          let position = 0;

          // 첫 페이지
          pdf.addImage(imageFile, "JPEG", 0, position, pageWidth, pageHeight);
          heightLeft -= pageHeight;

          // 나머지 페이지
          while (heightLeft > 0) {
            position = heightLeft - customHeight;
            pdf.addPage();
            pdf.addImage(
              imageFile,
              "JPEG",
              0,
              position,
              pageWidth,
              customHeight
            );
            heightLeft -= pageHeight;
          }
        }

        // 다음 섹션 추가 전에 페이지 넘기기
        if (i < elements.length - 1) {
          pdf.addPage();
        }
      }
    }

    // PDF 저장
    // pdf.save("group_modal.pdf");
    pdf.save(`그룹결과지_${input.groupname}.pdf`);
  };

  if (!isAdmin) return <Code code={code} setIsValid={setIsAdmin} />;

  return (
    <div className="AdminPage">
      <h4>[관리자 페이지]</h4>
      <h2 onClick={() => initData()}>진단 결과 목록</h2>
      <div className="search-container">
        <Search setKeyword={setKeyword} />
      </div>
      {keyword && (
        <>
          <div className="keyword">"{keyword}"에 대한 검색 결과입니다.</div>
          <div className="search-container">
            <Search setKeyword={setDetailKeyword} isDetail={true} />
          </div>
        </>
      )}
      <div className="table-container">
        {loading ? (
          <div className="loading">
            <PulseLoader color="hsla(194, 56%, 63%, 1)" />
          </div>
        ) : (
          <Table
            data={detailKeyword ? detailData : searchedData}
            setData={detailKeyword ? setDetailData : setSearchedData}
            isAscending={isAscending}
            headers={headers}
            widths={widths}
            sortBy={sortBy}
            setSortBy={setSortBy}
            setIsAscending={setIsAscending}
            handleCheckBox={handleCheckBox}
            handleDownloadExcel={handleDownloadExcel}
            sortDataFunc={sortDataFunc}
            initData={initData}
            setLoading={setLoading}
            courses={courses}
            getCourses={getCourses}
            handlePdfOpen={handlePdfOpen}
          />
        )}
      </div>
      {pdfLoading && (
        <div className="pdf-loading">
          <PulseLoader color="var(--navy700)" />
          다운로드 중입니다.
        </div>
      )}
      {showPdfModal && userInfo && (
        <div className="modal-container">
          <div className="pdf-modal" ref={pdfRef}>
            <PdfModal dataMain={dataMain} dataSub={dataSub} />
          </div>
          <div className="pdf-buttons">
            <button className="btn-download-pdf" onClick={onClickDownloadPdf}>
              다운로드
            </button>
            <button onClick={() => setShowPdfModal(false)}>×</button>
          </div>
          {pdfLoading && (
            <div className="pdf-loading">
              <PulseLoader color="var(--navy700)" />
              다운로드 중입니다.
            </div>
          )}
        </div>
      )}
      {showInputModal && groupUsers && (
        <div className="modal-container">
          <GroupInfoModal
            setShowInputModal={setShowInputModal}
            setShowGroupModal={setShowGroupModal}
            input={input}
            setInput={setInput}
          />
        </div>
      )}
      {showGroupModal && groupUsers && (
        <div className="modal-container">
          <GroupModal
            groupUsers={groupUsers}
            groupscore={groupscore}
            input={input}
            excelDataMain={excelDataMain}
            excelDataSub={excelDataSub}
          />
          <div className="pdf-buttons">
            <button onClick={() => setShowGroupModal(false)}>×</button>
            <button
              className="btn-download-pdf"
              onClick={onClickDownloadGroupModalPdf}
            >
              다운로드
            </button>
          </div>
        </div>
      )}
      {tempUserInfo && (
        <div style={{ position: "absolute", left: "-9999px" }}>
          <div className="pdf-modal" ref={pdfRef}>
            <PdfModal dataMain={dataMain} dataSub={dataSub} />
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminPage;
